import { useRouter } from 'next/router';
import React, { Fragment, useState, useEffect } from 'react';
import URI from 'urijs';
import { getOpenLayersFromLocation } from 'Utils/uri/uriUtils';
import { ProductInformationLayer } from './ProductInformationLayer';
import type { ProductInformationSliderProps } from './ProductInformationSlider';
import { ProductInformationSlider } from './ProductInformationSlider';
type ProductInformationSliderContainerProps = ProductInformationSliderProps & {
  theme?: string;
  queryLayer: string;
  renderDetail: (data: Record<string, any>) => Node;
  sliderIndex: number;
};
export const ProductInformationSliderContainer = (
  props: ProductInformationSliderContainerProps,
) => {
  // -1 to init activeItem (it means no item has been selected yet), 0 is the index of first element
  const [activeItem, setActiveItem] = useState(-1);
  const router = useRouter();
  const { queryLayer, sliderIndex } = props;
  const { asPath } = router;
  const [uriSliderIndex, uriActiveItem] = getOpenLayersFromLocation(asPath, queryLayer);
  const uri = new URI(asPath);
  useEffect(() => {
    if (uri.hasQuery(queryLayer) && Number(uriSliderIndex) === sliderIndex) {
      setActiveItem(uriActiveItem);
    }
  }, [asPath]);

  /**
   * Close the layer from back navigation button
   */
  const closeLayer = () => {
    setActiveItem(-1);
  };

  useEffect(() => {
    window.addEventListener('popstate', closeLayer);
    return () => {
      window.removeEventListener('popstate', closeLayer);
    };
  }, []);

  const toggleLayer = (item: number, layer: boolean): void => {
    let newUrl = uri.clone();

    if (layer) {
      newUrl = newUrl.hash('').addQuery(queryLayer, `${sliderIndex}_${item}`);
      router.push(newUrl.toString(), undefined, {
        shallow: true,
      });
    } else {
      newUrl = newUrl.removeQuery(queryLayer);
      router.replace(newUrl.toString(), undefined, {
        shallow: true,
      });
    }

    setActiveItem(item);
  };

  return (
    <Fragment>
      <ProductInformationSlider {...props} toggleLayer={toggleLayer} />
      <ProductInformationLayer {...props} activeItem={activeItem} toggleLayer={toggleLayer} />
    </Fragment>
  );
};
